// extracted by mini-css-extract-plugin
export default {"nav_title":"styles_nav_title__B0BvO","menu_item":"styles_menu_item__wZH3u"};